import React from 'react';
import { TrendingDown, TrendingUp } from 'react-feather';
import { Table, Badge } from 'reactstrap';
import { H6 } from '../../../AbstractElements';

const TransactionTable = ({ tableData, filterCoins, isUserData = true }) => {
  // Filter logic for user data
  let filteredData;
  
  if (filterCoins === 'All') {
    filteredData = tableData;
  } else if (filterCoins === 'Followed') {
    filteredData = tableData.filter((item) => item.followedOA === true);
  } else if (filterCoins === 'Not Followed') {
    filteredData = tableData.filter((item) => item.followedOA === false);
  } else {
    filteredData = tableData;
  }

  return (
    <Table>
      <tbody>
        {filteredData?.map((item, i) => (
          <tr key={item.userId || i}>
            <td>
              <div className='d-flex'>
                {item.trend === 'up' ? <TrendingUp className='font-success me-2' /> : <TrendingDown className='font-danger me-2' />}
                <div>
                  <H6 attrH6={{ className: 'f-14 mb-0' }}>
                    {item.title}
                    {item.followedOA !== undefined && (
                      <Badge color={item.followedOA ? 'light-success' : 'light-secondary'} className='ms-2 f-10'>
                        {item.followedOA ? 'Active' : 'Inactive'}
                      </Badge>
                    )}
                  </H6>
                  <span className='f-light'>{item.subTitle}</span>
                </div>
              </div>
            </td>
            <td>
              <span className='f-light f-w-500'>
                {item.price}
              </span>
              <span className='d-block f-light f-10'>{item.coins}</span>
            </td>
            <td>
              <span className='f-light f-w-500'>
                {item.totalPrice}
              </span>
            </td>
          </tr>
        ))}
        {filteredData?.length === 0 && (
          <tr>
            <td colSpan="3" className='text-center text-muted py-4'>
              <i className='fa fa-inbox fa-2x mb-2 d-block text-muted'></i>
              <span className='f-light'>No users match the selected filter</span>
            </td>
          </tr>
        )}
      </tbody>
    </Table>
  );
};

export default TransactionTable;
